<script>
import ucfirst from '../helpers/ucfirst'

export default {
    methods: {
        syncVuexWithSessionStorage () {
            const fields = {
                'currentAmount': 'amount',
                'paymentType': 'payment_type',
                'payerType': 'payer_type',
                'firstName': 'first_name',
                'lastName': 'last_name',
                'email': 'email',
                'corporateName': 'corporate_name',
                'taxId': 'tax_id',
                'streetAddress': 'street_address',
                'postalCode': 'postal_code',
                'city': 'city',
                'paymentMethod': 'payment_gateway'
            }

            for (const [storeKey, sessionStorageKey] of Object.entries(fields)) {
                let storeValue = this.$store.state[storeKey]
                let sessionStorageValue = window.sessionStorage.getItem(sessionStorageKey)

                if (storeValue !== sessionStorageValue) {
                    this.$store.commit('set' + ucfirst(storeKey), sessionStorageValue)
                }
            }
        }
    }
}
</script>
